// This file contains mock data for the Alerts page
import "../components/AlertsPage";

export interface Alert {
  id: string;
  type: string; // prometheus, datadog, etc.
  name: string;
  team: string;
  line: string;
  unit: string;
  region: string;
  runbook: string;
}

export interface AlertsData {
  totalAlerts: number;
  phases: {
    id: number;
    name: string;
    description: string;
    count: number;
    alerts: Alert[];
  }[];
}

// Data for different time ranges
export const alertsDataByTimeRange: Record<string, AlertsData> = {
  "Last 10m": {
    totalAlerts: 52,
    phases: [
      {
        id: 0,
        name: "Total Critical",
        description: "",
        count: 7,
        alerts: [
          {
            id: "1",
            type: "prometheus",
            name: "VmFromCannotScrape",
            team: "platform",
            line: "core-technologies",
            unit: "core-cloud",
            region: "ap-northeast-1",
            runbook: "https://next-docs.csquad.io/platform/promsta",
          },
          {
            id: "2",
            type: "prometheus",
            name: "ServicesIsDown",
            team: "dataengineering",
            line: "core-technologies",
            unit: "data-aggregation",
            region: "eu-west-1",
            runbook: "https://next-docs.csquad.io/",
          },
          {
            id: "3",
            type: "datadog",
            name: "[Synthetics] [Prod] JS Errors",
            team: "app",
            line: "dem",
            unit: "errors-for-web-apps",
            region: "eu-west-1",
            runbook: "https://next-docs.pr-258.csquad.io/platform",
          },
          {
            id: "4",
            type: "prometheus",
            name: "ZookeeperZeroAliveConnectionsCritical",
            team: "platform",
            line: "core-technologies",
            unit: "data-storage-streaming",
            region: "eu-west-1",
            runbook: "https://contentsquare.atlassian.net/wiki/x/VW",
          },
          {
            id: "5",
            type: "prometheus",
            name: "TagCheckerTagsCompromisedCloudfront",
            team: "datacollection",
            line: "core-technologies",
            unit: "tag-core",
            region: "eu-west-1",
            runbook: "https://contentsquare.atlassian.net/wiki/x/N4P",
          },
        ],
      },
      {
        id: 1,
        name: "Total Warning",
        description: "",
        count: 33,
        alerts: [
          {
            id: "6",
            type: "prometheus",
            name: "AwsAlbIngressControllerFailures",
            team: "platform",
            line: "core-technologies",
            unit: "core-cloud",
            region: "eu-west-1",
            runbook: "https://next-docs.csquad.io/platform/one-kud",
          },
          {
            id: "7",
            type: "prometheus",
            name: "AwsSesBounceRate",
            team: "platform",
            line: "core-technologies",
            unit: "production-reliability",
            region: "eu-west-1",
            runbook: "https://next-docs.csquad.io/platform/yace/run",
          },
          {
            id: "8",
            type: "prometheus",
            name: "AwsSesComplaintRate",
            team: "platform",
            line: "core-technologies",
            unit: "production-reliability",
            region: "eu-west-1",
            runbook: "https://next-docs.csquad.io/platform/yace/run",
          },
          {
            id: "9",
            type: "prometheus",
            name: "AwsSesUsage",
            team: "platform",
            line: "core-technologies",
            unit: "production-reliability",
            region: "eu-west-1",
            runbook: "https://next-docs.csquad.io/platform/quota-e",
          },
          {
            id: "10",
            type: "prometheus",
            name: "KubeClusterStatusReplicaUnavailable",
            team: "platform",
            line: "core-technologies",
            unit: "core-cloud",
            region: "eu-west-1",
            runbook: "https://next-docs.csquad.io/platform/one-kud",
          },
        ],
      },
      {
        id: 2,
        name: "Service Down",
        description: "",
        count: 0,
        alerts: [],
      },
      {
        id: 3,
        name: "Instance Down",
        description: "",
        count: 0,
        alerts: [
          {
            id: "1",
            type: "prometheus",
            name: "VmFromCannotScrape",
            team: "platform",
            line: "core-technologies",
            unit: "core-cloud",
            region: "ap-northeast-1",
            runbook: "https://next-docs.csquad.io/platform/promsta",
          },
          {
            id: "2",
            type: "prometheus",
            name: "ServicesIsDown",
            team: "dataengineering",
            line: "core-technologies",
            unit: "data-aggregation",
            region: "eu-west-1",
            runbook: "https://next-docs.csquad.io/",
          },
          {
            id: "3",
            type: "datadog",
            name: "[Synthetics] [Prod] JS Errors",
            team: "app",
            line: "dem",
            unit: "errors-for-web-apps",
            region: "eu-west-1",
            runbook: "https://next-docs.pr-258.csquad.io/platform",
          },
          {
            id: "4",
            type: "prometheus",
            name: "ZookeeperZeroAliveConnectionsCritical",
            team: "platform",
            line: "core-technologies",
            unit: "data-storage-streaming",
            region: "eu-west-1",
            runbook: "https://contentsquare.atlassian.net/wiki/x/VW",
          },
          {
            id: "5",
            type: "prometheus",
            name: "TagCheckerTagsCompromisedCloudfront",
            team: "datacollection",
            line: "core-technologies",
            unit: "tag-core",
            region: "eu-west-1",
            runbook: "https://contentsquare.atlassian.net/wiki/x/N4P",
          },
        ],
      },
    ],
  },
  "Last 30m": {
    totalAlerts: 142,
    phases: [
      {
        id: 0,
        name: "Total Critical",
        description: "",
        count: 35,
        alerts: [
          {
            id: "1",
            type: "prometheus",
            name: "VmFromCannotScrape",
            team: "platform",
            line: "core-technologies",
            unit: "core-cloud",
            region: "ap-northeast-1",
            runbook: "https://next-docs.csquad.io/platform/promsta",
          },
          {
            id: "2",
            type: "prometheus",
            name: "ServicesIsDown",
            team: "dataengineering",
            line: "core-technologies",
            unit: "data-aggregation",
            region: "eu-west-1",
            runbook: "https://next-docs.csquad.io/",
          },
          {
            id: "3",
            type: "datadog",
            name: "[Synthetics] [Prod] JS Errors",
            team: "app",
            line: "dem",
            unit: "errors-for-web-apps",
            region: "eu-west-1",
            runbook: "https://next-docs.pr-258.csquad.io/platform",
          },
          {
            id: "4",
            type: "prometheus",
            name: "ZookeeperZeroAliveConnectionsCritical",
            team: "platform",
            line: "core-technologies",
            unit: "data-storage-streaming",
            region: "eu-west-1",
            runbook: "https://contentsquare.atlassian.net/wiki/x/VW",
          },
          {
            id: "5",
            type: "prometheus",
            name: "TagCheckerTagsCompromisedCloudfront",
            team: "datacollection",
            line: "core-technologies",
            unit: "tag-core",
            region: "eu-west-1",
            runbook: "https://contentsquare.atlassian.net/wiki/x/N4P",
          },
        ],
      },
      {
        id: 1,
        name: "Total Warning",
        description: "",
        count: 107,
        alerts: [
          {
            id: "6",
            type: "prometheus",
            name: "AwsAlbIngressControllerFailures",
            team: "platform",
            line: "core-technologies",
            unit: "core-cloud",
            region: "eu-west-1",
            runbook: "https://next-docs.csquad.io/platform/one-kud",
          },
          {
            id: "7",
            type: "prometheus",
            name: "AwsSesBounceRate",
            team: "platform",
            line: "core-technologies",
            unit: "production-reliability",
            region: "eu-west-1",
            runbook: "https://next-docs.csquad.io/platform/yace/run",
          },
          {
            id: "8",
            type: "prometheus",
            name: "AwsSesComplaintRate",
            team: "platform",
            line: "core-technologies",
            unit: "production-reliability",
            region: "eu-west-1",
            runbook: "https://next-docs.csquad.io/platform/yace/run",
          },
          {
            id: "9",
            type: "prometheus",
            name: "AwsSesUsage",
            team: "platform",
            line: "core-technologies",
            unit: "production-reliability",
            region: "eu-west-1",
            runbook: "https://next-docs.csquad.io/platform/quota-e",
          },
          {
            id: "10",
            type: "prometheus",
            name: "KubeClusterStatusReplicaUnavailable",
            team: "platform",
            line: "core-technologies",
            unit: "core-cloud",
            region: "eu-west-1",
            runbook: "https://next-docs.csquad.io/platform/one-kud",
          },
        ],
      },
      {
        id: 2,
        name: "Service Down",
        description: "",
        count: 0,
        alerts: [],
      },
      {
        id: 3,
        name: "Instance Down",
        description: "",
        count: 0,
        alerts: [
          {
            id: "1",
            type: "prometheus",
            name: "VmFromCannotScrape",
            team: "platform",
            line: "core-technologies",
            unit: "core-cloud",
            region: "ap-northeast-1",
            runbook: "https://next-docs.csquad.io/platform/promsta",
          },
          {
            id: "2",
            type: "prometheus",
            name: "ServicesIsDown",
            team: "dataengineering",
            line: "core-technologies",
            unit: "data-aggregation",
            region: "eu-west-1",
            runbook: "https://next-docs.csquad.io/",
          },
          {
            id: "3",
            type: "datadog",
            name: "[Synthetics] [Prod] JS Errors",
            team: "app",
            line: "dem",
            unit: "errors-for-web-apps",
            region: "eu-west-1",
            runbook: "https://next-docs.pr-258.csquad.io/platform",
          },
          {
            id: "4",
            type: "prometheus",
            name: "ZookeeperZeroAliveConnectionsCritical",
            team: "platform",
            line: "core-technologies",
            unit: "data-storage-streaming",
            region: "eu-west-1",
            runbook: "https://contentsquare.atlassian.net/wiki/x/VW",
          },
          {
            id: "5",
            type: "prometheus",
            name: "TagCheckerTagsCompromisedCloudfront",
            team: "datacollection",
            line: "core-technologies",
            unit: "tag-core",
            region: "eu-west-1",
            runbook: "https://contentsquare.atlassian.net/wiki/x/N4P",
          },
        ],
      },
    ],
  },
  "Last 1h": {
    totalAlerts: 183,
    phases: [
      {
        id: 0,
        name: "Total Critical",
        description: "",
        count: 48,
        alerts: [
          // Alerts would be listed here
        ],
      },
      {
        id: 1,
        name: "Total Warning",
        description: "",
        count: 135,
        alerts: [],
      },
      {
        id: 2,
        name: "Service Down",
        description: "",
        count: 0,
        alerts: [],
      },
      {
        id: 3,
        name: "Instance Down",
        description: "",
        count: 0,
        alerts: [],
      },
    ],
  },
  "Last 6h": {
    totalAlerts: 205,
    phases: [
      {
        id: 0,
        name: "Total Critical",
        description: "",
        count: 52,
        alerts: [
          {
            id: "1",
            type: "prometheus",
            name: "VmFromCannotScrape",
            team: "platform",
            line: "core-technologies",
            unit: "core-cloud",
            region: "ap-northeast-1",
            runbook: "https://next-docs.csquad.io/platform/promsta",
          },
          {
            id: "2",
            type: "prometheus",
            name: "ServicesIsDown",
            team: "dataengineering",
            line: "core-technologies",
            unit: "data-aggregation",
            region: "eu-west-1",
            runbook: "https://next-docs.csquad.io/",
          },
          {
            id: "3",
            type: "datadog",
            name: "[Synthetics] [Prod] JS Errors",
            team: "app",
            line: "dem",
            unit: "errors-for-web-apps",
            region: "eu-west-1",
            runbook: "https://next-docs.pr-258.csquad.io/platform",
          },
          {
            id: "4",
            type: "prometheus",
            name: "ZookeeperZeroAliveConnectionsCritical",
            team: "platform",
            line: "core-technologies",
            unit: "data-storage-streaming",
            region: "eu-west-1",
            runbook: "https://contentsquare.atlassian.net/wiki/x/VW",
          },
          {
            id: "5",
            type: "prometheus",
            name: "TagCheckerTagsCompromisedCloudfront",
            team: "datacollection",
            line: "core-technologies",
            unit: "tag-core",
            region: "eu-west-1",
            runbook: "https://contentsquare.atlassian.net/wiki/x/N4P",
          },
        ],
      },
      {
        id: 1,
        name: "Total Warning",
        description: "",
        count: 146,
        alerts: [
          {
            id: "1",
            type: "prometheus",
            name: "VmFromCannotScrape",
            team: "platform",
            line: "core-technologies",
            unit: "core-cloud",
            region: "ap-northeast-1",
            runbook: "https://next-docs.csquad.io/platform/promsta",
          },
          {
            id: "2",
            type: "prometheus",
            name: "ServicesIsDown",
            team: "dataengineering",
            line: "core-technologies",
            unit: "data-aggregation",
            region: "eu-west-1",
            runbook: "https://next-docs.csquad.io/",
          },
          {
            id: "3",
            type: "datadog",
            name: "[Synthetics] [Prod] JS Errors",
            team: "app",
            line: "dem",
            unit: "errors-for-web-apps",
            region: "eu-west-1",
            runbook: "https://next-docs.pr-258.csquad.io/platform",
          },
          {
            id: "4",
            type: "prometheus",
            name: "ZookeeperZeroAliveConnectionsCritical",
            team: "platform",
            line: "core-technologies",
            unit: "data-storage-streaming",
            region: "eu-west-1",
            runbook: "https://contentsquare.atlassian.net/wiki/x/VW",
          },
          {
            id: "5",
            type: "prometheus",
            name: "TagCheckerTagsCompromisedCloudfront",
            team: "datacollection",
            line: "core-technologies",
            unit: "tag-core",
            region: "eu-west-1",
            runbook: "https://contentsquare.atlassian.net/wiki/x/N4P",
          },
        ],
      },
      {
        id: 2,
        name: "Service Down",
        description: "",
        count: 1,
        alerts: [
          {
            id: "1",
            type: "prometheus",
            name: "VmFromCannotScrape",
            team: "platform",
            line: "core-technologies",
            unit: "core-cloud",
            region: "ap-northeast-1",
            runbook: "https://next-docs.csquad.io/platform/promsta",
          },
        ],
      },
      {
        id: 3,
        name: "Instance Down",
        description: "",
        count: 4,
        alerts: [],
      },
    ],
  },
  "Last 24h": {
    totalAlerts: 227,
    phases: [
      {
        id: 0,
        name: "Total Critical",
        description: "",
        count: 68,
        alerts: [
          {
            id: "1",
            type: "prometheus",
            name: "VmFromCannotScrape",
            team: "platform",
            line: "core-technologies",
            unit: "core-cloud",
            region: "ap-northeast-1",
            runbook: "https://next-docs.csquad.io/platform/promsta",
          },
          // Additional alerts would be here
        ],
      },
      {
        id: 1,
        name: "Total Warning",
        description: "",
        count: 159,
        alerts: [],
      },
      {
        id: 2,
        name: "Service Down",
        description: "",
        count: 3,
        alerts: [
          {
            id: "1",
            type: "prometheus",
            name: "VmFromCannotScrape",
            team: "platform",
            line: "core-technologies",
            unit: "core-cloud",
            region: "ap-northeast-1",
            runbook: "https://next-docs.csquad.io/platform/promsta",
          },
          {
            id: "2",
            type: "prometheus",
            name: "ServicesIsDown",
            team: "dataengineering",
            line: "core-technologies",
            unit: "data-aggregation",
            region: "eu-west-1",
            runbook: "https://next-docs.csquad.io/",
          },
          {
            id: "3",
            type: "prometheus",
            name: "ServicesIsDown",
            team: "dataengineering",
            line: "core-technologies",
            unit: "data-aggregation",
            region: "eu-west-1",
            runbook: "https://next-docs.csquad.io/",
          },
        ],
      },
      {
        id: 3,
        name: "Instance Down",
        description: "",
        count: 11,
        alerts: [],
      },
    ],
  },
};

// Default data to export for compatibility
export const alertsData = alertsDataByTimeRange["Last 24h"];
